module.exports = __webpack_public_path__ + "static/media/Team 23 - Alpha Centauri Co..ea10eafe.png";